<template>
  <div class="city-contain">
    <div v-for="(item, index) in rankList" :key="index" class="city-body">
      <div v-if="showAll || index < firstSize" class="city-box">
        <div class="city-id">{{index + 1}}</div>
        <div class="city-name" :class="index > 4?'no-change':''" :style="{width:maxWidth}">&#160;{{item.areaName}}</div>
        <div class="right-box">
          <!-- <div class="line-box">
            <div class="line" :style="'width:' + (item.score / maxLine) * 100 + '%'"></div>
          </div> -->
          <div class="mark">{{item.score}}分</div>

          <div class="rank-box">
            <div
              :class="index%2 !== 1?'num-up num':'num-down num'"
              v-if="index <= 4"
            >-</div>
            <div
              :class="item.change !== 1?'num-up num':'num-down num'"
              v-if="index <= 4"
            >{{index}}</div>
            <div class="up-up" v-if="index%2 !== 0 && index <= 4">↑</div>
            <div class="down-down" v-if="index%2 !== 1 && index <= 4">↓</div>
            <div class="no-change" v-if="index > 4">持平</div>
          </div>
        </div>
      </div>
    </div>
    <div class="more-box" @click="handleShowAll" v-if="!showAll && rankList.length > firstSize">
      <span>展开所有排名</span>
      <img src="../../../assets/guideSystem/show_more.png" />
    </div>
  </div>
</template>

<script>
    export default {
        name: 'guideRankCharts',
        props: {
            rankList: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            firstSize: {
                type: Number,
                default: () => {
                    return 10;
                }
            }
        },
        data () {
            return {
                showAll: false
            };
        },
        computed: {
            maxWidth () {
                let max = 0;
                let nameArry = [];
                this.rankList.forEach(item => {
                    nameArry.push(item.areaName);
                });
                if (nameArry.length > 0) {
                    var longest = nameArry.sort(function (a, b) {
                        return b.length - a.length;
                    })[0];
                    max = longest.length * 18.5;
                    return max > 30 ? max + 'px' : '30px';
                } else {
                    return '30px';
                }
            },
            maxLine () {
                this.handleShowAll(false);
                return this.rankList[0].score || 0;
            }
        },
        mounted () {},
        methods: {
            handleShowAll (state = true) {
                this.showAll = state;
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.city-contain {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .city-body:last-child{
    border-bottom: 0!important;
  }
  .city-body{
    border-bottom: 1px solid #eeeeee;
    .city-box {
      height: 34px;
      width: 100%;
      display: flex;
      align-items: center;
      .city-id {
        width: 23px;
        color: #333333;
        font-size: 12px;
        line-height: 12px;
        font-weight: bold;
        font-family: DIN-Bold, DIN;
      }
      .city-name {
        display: flex;
        justify-content: flex-start;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 12px;
        white-space: nowrap;
        &.no-change{
          color: #FF4D4D
        }
      }
      .right-box {
        margin-left: 12px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        .line-box {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: 100%;
          .line {
            height: 6px;
            background: #36b374;
          }
        }
        .mark {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 12px;
          margin-left: 12px;
          white-space: nowrap;
        }
        .rank-box {
          margin-left: 24px;
          width: 24px;
          margin-right: 4px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .up-up {
            font-size: 12px;
            font-weight: 400;
            color: rgba(54, 179, 116, 1);
            line-height: 12px;
            margin-bottom: 2.5px;
          }
          .down-down {
            font-size: 12px;
            font-weight: 400;
            color: rgba(255, 77, 77, 1);
            line-height: 12px;
            margin-bottom: 2.5px;
          }
          .no-change {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: rgba(34, 131, 230, 1);
            line-height: 12px;
          }
          .num {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 12px;
            margin-left: 4px;
          }
          .num-up {
            color: rgba(54, 179, 116, 1);
          }
          .num-down {
            color: rgba(255, 77, 77, 1);
          }
        }
      }
    }
  }

  .more-box {
    height: 49px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: #9b9b9b;
    img {
      height: 4px;
      width: 7px;
      margin-left: 3px;
    }
  }
}
</style>
